module.exports = __webpack_public_path__ + "img/enterpriseTrainingImg2.8e386798.png";